import React, { useContext } from "react";
import Color from "color";
import styled from "styled-components";
import { Button as MUIButton } from "@material-ui/core";

import { UserContext } from "../../../contexts/UserContext";

export const Button = ({
  children,
  type,
  colour,
  variant,
  margin,
  onClick,
  disabled,
  startIcon,
  endIcon,
  ...props
}) => {
  const { Site } = useContext(UserContext);
  return (
    <StyledButton
      type={type}
      variant={
        !variant && Site.theme === "light"
          ? "contained"
          : variant
          ? variant
          : "outlined"
      }
      onClick={onClick}
      disabled={disabled}
      colour={colour}
      startIcon={startIcon}
      endIcon={endIcon}
      margin={margin}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(MUIButton)`
  margin: ${({ margin }) => margin ?? "0"};
  font-size: 1.6rem;
  background: ${({ theme, variant, colour }) =>
    colour && variant === "contained"
      ? theme.palette[colour].main
      : variant === "contained" && !colour
      ? theme.palette.text.secondary
      : "none"};
  color: ${({ theme, variant, colour }) =>
    variant === "contained"
      ? theme.palette.primary.main
      : colour
      ? theme.palette[colour].main
      : theme.palette.text.secondary};
  border-color: ${({ theme, variant, colour }) =>
    variant === "contained"
      ? "transparent"
      : !colour
      ? theme.palette.text.secondary
      : theme.palette[colour].main};
  &:hover {
    background: ${({ theme, variant, colour }) =>
      variant === "contained"
        ? Color(
            !colour ? theme.palette.text.secondary : theme.palette[colour].main
          )
            .fade(0.2)
            .string()
        : Color(
            !colour ? theme.palette.text.secondary : theme.palette[colour].main
          )
            .fade(0.85)
            .string()};
  }
`;
